import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/close_white_icon.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle-border-green.svg'
import _imports_2 from '@/app/ui/assets/svg/x-circle-outline-dark-red.svg'
import _imports_3 from '@/app/ui/assets/svg/x-gray.svg'
import _imports_4 from '@/app/ui/assets/svg/refresh-green.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-79638602")

_pushScopeId("data-v-79638602")
const _hoisted_1 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "flex gap-x-6 justify-between items-start"
}
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  alt: "check-circle"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_2,
  alt: "x-circle-outline-dark-red"
}
const _hoisted_6 = {
  key: 0,
  class: "font-semibold text-black-lp-300",
  style: {"width":"24rem"}
}
const _hoisted_7 = {
  key: 0,
  class: "bg-yellow-lp-500 px-1 text-xs text-white font-medium rounded mt-1",
  style: {"width":"fit-content"}
}
const _hoisted_8 = { class: "font-normal mt-2" }
const _hoisted_9 = { class: "flex flex-row" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "w-5/12" }, " No. STT ", -1)
const _hoisted_11 = { class: "w-7/12" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_13 = { class: "w-5/12" }
const _hoisted_14 = { class: "w-7/12" }
const _hoisted_15 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_16 = { class: "w-5/12" }
const _hoisted_17 = { class: "w-7/12" }
const _hoisted_18 = { class: "flex flex-row" }
const _hoisted_19 = { class: "w-5/12" }
const _hoisted_20 = { class: "w-7/12" }
const _hoisted_21 = { class: "flex flex-row" }
const _hoisted_22 = { class: "w-5/12" }
const _hoisted_23 = { class: "w-7/12 truncate" }
const _hoisted_24 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_25 = { class: "w-5/12" }
const _hoisted_26 = { class: "w-7/12 truncate" }
const _hoisted_27 = { class: "flex flex-row" }
const _hoisted_28 = { class: "w-5/12" }
const _hoisted_29 = { class: "w-7/12" }
const _hoisted_30 = { class: "flex flex-row" }
const _hoisted_31 = { class: "w-5/12" }
const _hoisted_32 = { class: "w-7/12" }
const _hoisted_33 = {
  key: 1,
  class: "font-semibold text-black-lp-300 w-350px"
}
const _hoisted_34 = { class: "font-normal mt-2" }
const _hoisted_35 = { class: "flex flex-row" }
const _hoisted_36 = { class: "w-6/12" }
const _hoisted_37 = { class: "w-6/12" }
const _hoisted_38 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_39 = { class: "w-6/12 whitespace-no-wrap" }
const _hoisted_40 = { class: "w-6/12 whitespace-no-wrap" }
const _hoisted_41 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_42 = { class: "w-6/12 whitespace-no-wrap" }
const _hoisted_43 = { class: "w-6/12 whitespace-no-wrap" }
const _hoisted_44 = { class: "flex flex-row" }
const _hoisted_45 = { class: "w-6/12" }
const _hoisted_46 = { class: "w-6/12" }
const _hoisted_47 = {
  key: 2,
  class: "flex gap-x-4 flex-row justify-between items-start"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  style: {"width":"24px"},
  alt: "refresh-green"
}, null, -1)
const _hoisted_49 = { class: "flex flex-col justify-betweenx" }
const _hoisted_50 = { class: "mt-1 mb-3 text-sm text-gray-lp-300 font-semibold" }
const _hoisted_51 = { class: "mb-3 text-sm text-gray-lp-300" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock(_Transition, { name: "notification" }, {
    default: _withId(() => [
      (_ctx.modelValue || (_ctx.modelValue && _ctx.data && _ctx.data.sttNumber))
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: 
        `notification-card ${_ctx.customStyles?.background ||
          'bg-white'} text-12px xxl:text-14px w-auto z-60 border ${_ctx.customStyles?.border ||
          'border-gray-lp-400'} px-4 ${
          _ctx.data?.sttNumber ? 'py-5' : 'py-3'
        } shadow-md rounded-md font-montserrat`
      
          }, [
            (_ctx.isCustom && !_ctx.hasChild)
              ? (_openBlock(), _createBlock("div", _hoisted_1, [
                  (!!_ctx.icon)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: require(`@/app/ui/assets/svg/${_ctx.icon}.svg`),
                        class: "w-10 max-w-none",
                        alt: "custom-icon"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  _createVNode("span", {
                    class: `${_ctx.customStyles?.text} text-12px`
                  }, _toDisplayString(_ctx.message), 3),
                  (_ctx.showIconClose)
                    ? (_openBlock(), _createBlock("div", _hoisted_2, [
                        (!_ctx.customIconClose)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: _imports_0,
                              class: "w-3 max-w-none ml-6 cursor-pointer",
                              alt: "close-white-icon",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeNotification && _ctx.closeNotification(...args)))
                            }))
                          : (_openBlock(), _createBlock(_component_Icons, {
                              key: 1,
                              name: "icon-x",
                              class: `${_ctx.customStyles?.text} cursor-pointer`,
                              onClick: _ctx.closeNotification
                            }, null, 8, ["class", "onClick"]))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.data || _ctx.hasChild)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    (_ctx.status === 'success')
                      ? (_openBlock(), _createBlock("img", _hoisted_4))
                      : (_openBlock(), _createBlock("img", _hoisted_5)),
                    (_ctx.hasChild)
                      ? _renderSlot(_ctx.$slots, "content", { key: 2 }, undefined, true)
                      : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                          (_ctx.status === 'success')
                            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                                _createTextVNode(_toDisplayString(_ctx.$t("Input No. STT berhasil -")) + " " + _toDisplayString(_ctx.data.sttNumber) + " ", 1),
                                (_ctx.data.isDangerousGoods)
                                  ? (_openBlock(), _createBlock("div", _hoisted_7, " DANGEROUS GOODS "))
                                  : _createCommentVNode("", true),
                                _createVNode("div", _hoisted_8, [
                                  _createVNode("div", _hoisted_9, [
                                    _hoisted_10,
                                    _createVNode("div", _hoisted_11, ": " + _toDisplayString(_ctx.data.sttNumber), 1)
                                  ]),
                                  (_ctx.data.destinationCity)
                                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("Kota Tujuan")), 1),
                                        _createVNode("div", _hoisted_14, ": " + _toDisplayString(_ctx.data.destinationCity), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.data.region)
                                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                                        _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("Wilayah")), 1),
                                        _createVNode("div", _hoisted_17, ": " + _toDisplayString(_ctx.data.region), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("div", _hoisted_18, [
                                    _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("Produk")), 1),
                                    _createVNode("div", _hoisted_20, ": " + _toDisplayString(_ctx.data.product), 1)
                                  ]),
                                  _createVNode("div", _hoisted_21, [
                                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("Komoditas")), 1),
                                    _createVNode("div", _hoisted_23, ": " + _toDisplayString(_ctx.data.commodity), 1)
                                  ]),
                                  (_ctx.data.commodityGroupName)
                                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                                        _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("Komoditas Group")), 1),
                                        _createVNode("div", _hoisted_26, " : " + _toDisplayString(_ctx.data.commodityGroupName), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("div", _hoisted_27, [
                                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("Total Koli")), 1),
                                    _createVNode("div", _hoisted_29, ": " + _toDisplayString(_ctx.data.totalPieces), 1)
                                  ]),
                                  _createVNode("div", _hoisted_30, [
                                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("Biaya COD")), 1),
                                    _createVNode("div", _hoisted_32, " : " + _toDisplayString(_ctx.data.codAmount ? _ctx.formatPrice(Number(_ctx.data.codAmount)) : "-"), 1)
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_33, [
                                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.titleMessageError)) + " ", 1),
                                _createVNode("div", _hoisted_34, [
                                  _createVNode("div", _hoisted_35, [
                                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.isSttNo ? _ctx.$t("No. STT") : _ctx.$t("No. Bagging")), 1),
                                    _createVNode("div", _hoisted_37, ": " + _toDisplayString(_ctx.data.sttNumber), 1)
                                  ]),
                                  (_ctx.data.destinationCity)
                                    ? (_openBlock(), _createBlock("div", _hoisted_38, [
                                        _createVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("Kota Tujuan")), 1),
                                        _createVNode("div", _hoisted_40, " : " + _toDisplayString(_ctx.data.destinationCity), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.data.region)
                                    ? (_openBlock(), _createBlock("div", _hoisted_41, [
                                        _createVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("Wilayah")), 1),
                                        _createVNode("div", _hoisted_43, ": " + _toDisplayString(_ctx.data.region), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("div", _hoisted_44, [
                                    _createVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("Catatan")), 1),
                                    _createVNode("div", _hoisted_46, ": " + _toDisplayString(_ctx.$t(_ctx.messageError)), 1)
                                  ])
                                ])
                              ]))
                        ], 64)),
                    _createVNode("img", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeNotification && _ctx.closeNotification(...args))),
                      src: _imports_3,
                      class: "cursor-pointer",
                      alt: "close-icon"
                    })
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode("div", _hoisted_49, [
                      _createVNode("p", _hoisted_50, _toDisplayString(_ctx.$t("Perbarui Halaman")), 1),
                      _createVNode("p", _hoisted_51, _toDisplayString(_ctx.$t("Terdapat data baru, silahkan perbarui<br />halaman.")), 1),
                      _createVNode("p", {
                        class: "text-red-lp-400 text-sm cursor-pointer hover:underline",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onRefresh && _ctx.onRefresh(...args)))
                      }, _toDisplayString(_ctx.$t("Perbarui")), 1)
                    ]),
                    _createVNode("img", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeNotification && _ctx.closeNotification(...args))),
                      src: _imports_3,
                      class: "cursor-pointer",
                      style: {"width":"20px"},
                      alt: "close-icon"
                    })
                  ]))
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
})